import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import {
  addQueueProductKnowledgeCount,
  resetQueueProductKnowledgeCount,
} from '../../../store/emarsys/action';
import { store } from '../../../store';

export default function eventClickProductKnowledgeList(
  title: string,
  category: string,
  pageNumber: number,
  sectionName: string,
  buttonName: string,
  reviewName?: string
) {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isProductKnowledgeActive = getFlagValue(FLAG_ENUM.EMARSYS_PRODUCT_KNOWLEDGE_LIST);
  if (!isFlagActive || !isProductKnowledgeActive) return;
  const state = store.getState();
  const { userData } = state.auth || {
    userData: null,
  };
  if (userData?.customerNo) {
    ScarabQueue.push(['setCustomerId', userData?.customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: 'review produk listing page',
    page_url: window.location.href,
    page_title: title,
    page_category: category?.toLowerCase(),
    section_name: sectionName,
    page_number: pageNumber,
    button_name: buttonName,
  };

  if (reviewName) {
    valueClickAction.review_name = reviewName;
  }

  for (const key in valueClickAction) {
    if (typeof valueClickAction[key] !== 'boolean' && !valueClickAction[key]) {
      delete valueClickAction[key];
    }
  }

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);

  if (sectionName === 'list review' || sectionName === 'page_category') {
    ScarabQueue.push(['go']);
    store.dispatch(resetQueueProductKnowledgeCount());
  } else {
    store.dispatch(addQueueProductKnowledgeCount());
  }
}
